<div class="main-container">
    <div class="close-icon">
        <button class="close-icon-style" mat-button matDialogClose>
            <span class="material-icons">
                close
            </span></button>
    </div>
    <div class="info-text bold-font" translate="lblTitleInfo" autofocus>Info</div>
    <div class="header-text bold-font" translate="lblPeopleServed">People Served</div>
    <div class="activity" translate="lblPeopleServedCap">3,000 cap per club service activity</div>
    <div class="header-text bold-font" translate="lblTotalVolunteerHours">Total Volunteer Hours</div>
    <div class="activity" translate="lblTotalVolunteerHoursCap">1,200 cap per club service activity</div>
    <div class="header-text bold-font" translate="lblTotalDonatedtoNonLCIF">Funds Donated</div>
    <div class="activity" translate="lblFundsDonatedCap">$200,000 cap per club service activity</div>
    <div class="header-text bold-font" translate="lblFundsRaised">Funds Raised</div>
    <div class="activity" translate="lblFundsRaisedCap">$250,000 cap per club service activity</div>
    <div class="close-button"><button class="ok-button bold-font" translate="lblOK" [mat-dialog-close]="true">Ok</button></div>
</div>